import { useRef, useState, useCallback } from 'react';

function useAsyncDebounce(fn, delay) {
    const latestCallRef = useRef(0);
    const timeoutRef = useRef(null);
    const resolveRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const debounced = useCallback((...args) => {
        latestCallRef.current += 1;
        const callId = latestCallRef.current;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (resolveRef.current) {
            resolveRef.current(undefined); // cancel previous call
        }
        setLoading(true);
        return new Promise((resolve) => {
            resolveRef.current = resolve;
            timeoutRef.current = setTimeout(async () => {
                try {
                    const result = await fn(...args);
                    if (callId === latestCallRef.current) {
                        resolve(result);
                    }
                    else {
                        resolve(undefined);
                    }
                }
                catch (_error) {
                    resolve(undefined);
                }
                finally {
                    // Only turn off loading if this is the latest call
                    if (callId === latestCallRef.current) {
                        setLoading(false);
                    }
                    resolveRef.current = null;
                }
            }, delay);
        });
    }, [fn, delay]);
    return { fn: debounced, loading };
}

export { useAsyncDebounce };
//# sourceMappingURL=useAsyncDebounce.js.map
